
import {Component, Mixins} from "vue-property-decorator";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import TakipAltTipForm from "@/components/forms/TakipAltTipForm.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import {HesapSekliLabel} from "@/enum/HesapSekli";
import {FaizTuruLabel} from "@/enum/FaizTuruLabel";

@Component({
  components: {FormDialog, TakipAltTipForm},
})
export default class TakipAltTipInfo extends Mixins(ObjectInputMixin) {
  hesapSekliLabel = HesapSekliLabel;
  faizTuruLabel = FaizTuruLabel
  faizTurleri:any[] =  [];

  async getFaizTurleri(){
    let response = await this.$helper.requestWithCache("/api/v1/faiz-turu/?takibe_ozel_mi=false");
    this.faizTurleri = response.data;
  }

  mounted() {
    this.getFaizTurleri();
  }


  getTakipOncesiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id == item);
    return faizTuruIsim?.isim;
  }
  getTakipSonrasiFaizTuruIsim(item:any){
    const faizTuruIsim = this.faizTurleri.find((ft: any) => ft.id == item);
    return faizTuruIsim?.isim;
  }
  load() {
    this.$emit('load');
  }
}
